import React from 'react';
import { PageLayout } from '@/shared/layout';
import { Button, Card, Switch } from '@/components/ui';
import { useAuth } from '@/core/auth/AuthContext';
import { usePermission } from '@/core/permissions/usePermission';
import { useCompanyAuditLogs } from './hooks/useCompany';
import { AuditLogsDesktopTable } from './components/AuditLogsDesktopTable';
import { AuditLogsMobileList } from './components/AuditLogsMobileList';

export default function CompanySecurityPage() {
  const { profile } = useAuth();
  const { can } = usePermission();
  const { data: logs, isLoading } = useCompanyAuditLogs(profile?.company_id || '');

  const breadcrumbs = [
    { label: 'Công ty', path: '/company' },
    { label: 'Bảo mật' }
  ];

  return (
    <PageLayout
      title="Bảo mật & Nhật ký"
      description="Quản lý cấu hình bảo mật hệ thống và theo dõi nhật ký hoạt động của tổ chức."
      breadcrumbs={breadcrumbs}
    >
      <div className="space-y-8">
        {/* Security Settings */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card className="p-6">
            <h4 className="font-bold text-slate-900 mb-6 flex items-center gap-2">
              <i className="ri-shield-user-line text-os-primary" />
              Chính sách đăng nhập
            </h4>
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-slate-900">Bắt buộc 2FA (MFA)</p>
                  <p className="text-xs text-slate-500">Yêu cầu tất cả nhân viên sử dụng xác thực 2 lớp.</p>
                </div>
                <Switch checked={true} onChange={() => {}} disabled={!can('companies', 'manage_security')} />
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-slate-900">Đăng nhập bằng Google</p>
                  <p className="text-xs text-slate-500">Cho phép nhân viên đăng nhập qua Google OAuth.</p>
                </div>
                <Switch checked={true} onChange={() => {}} disabled={!can('companies', 'manage_security')} />
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-slate-900">Tự động đăng xuất</p>
                  <p className="text-xs text-slate-500">Đăng xuất người dùng sau 4 tiếng không hoạt động.</p>
                </div>
                <Switch checked={false} onChange={() => {}} disabled={!can('companies', 'manage_security')} />
              </div>
            </div>
          </Card>

          <Card className="p-6">
            <h4 className="font-bold text-slate-900 mb-6 flex items-center gap-2">
              <i className="ri-lock-password-line text-os-primary" />
              Chính sách mật khẩu
            </h4>
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-slate-900">Mật khẩu mạnh</p>
                  <p className="text-xs text-slate-500">Yêu cầu chữ hoa, số và ký tự đặc biệt.</p>
                </div>
                <Switch checked={true} onChange={() => {}} disabled={!can('companies', 'manage_security')} />
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-slate-900">Hết hạn mật khẩu</p>
                  <p className="text-xs text-slate-500">Yêu cầu đổi mật khẩu định kỳ mỗi 90 ngày.</p>
                </div>
                <Switch checked={false} onChange={() => {}} disabled={!can('companies', 'manage_security')} />
              </div>
            </div>
            <div className="mt-8">
              <Button variant="outline" size="sm" className="w-full">Thiết lập IP Whitelist</Button>
            </div>
          </Card>
        </div>

        {/* Audit Logs Table */}
        <div className="space-y-4">
          <div className="flex justify-between items-center px-1">
            <div>
              <h3 className="text-lg font-semibold text-slate-900">Nhật ký hoạt động</h3>
              <p className="text-xs text-slate-500">Hiển thị 50 hoạt động gần nhất của hệ thống.</p>
            </div>
            <Button variant="ghost" size="sm" icon="ri-download-line">Xuất nhật ký</Button>
          </div>

          <Card className="overflow-hidden">
            <div className="hidden md:block">
              <AuditLogsDesktopTable logs={logs || []} isLoading={isLoading} />
            </div>
            <div className="md:hidden">
              <AuditLogsMobileList logs={logs || []} isLoading={isLoading} />
            </div>
          </Card>
        </div>
      </div>
    </PageLayout>
  );
}
